import React, { useRef, useState, useEffect } from "react";
import Tickets from "./Tickets";
import ticketDefaultFields from "./default-fields";
import { fireNotify } from "../../utils/utils";
import { __ } from '@wordpress/i18n';

const AddTicket = () => {
  const [fields, setFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [formError, setFormerror] = useState({});
  const [uploadFiles, setUplaodFiles] = useState(null);
  const [loading, setLoading] = useState(true);
  const [allTicketClick, setAllTicketClick] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  // Methods
  const form = useRef(null);
  const uploadref = useRef(null);
  const getTicketFields = async () => {
    const formdata = new FormData();
    formdata.append("action", "hive_support_get_ticketfields_frontend");
    formdata.append("mailboxid", Number(shortcodes_data.mailbox_id));
    // const request = await fetch(window.hive_support_client_script_object.ajaxurl, {
    const request = await fetch(hive_support_client_script_object.ajaxurl, {
      method: "POST",
      body: formdata,
    });

    const response = await request.json();

    if (response.success) {
      setLoading(false);

      let customFields = JSON.parse(response.data);

      let getTicketDefaultFields = [...ticketDefaultFields, ...customFields];

      setFields(getTicketDefaultFields);
    }
  };

  const TicketFormData = {
    action: "add_ticket_from_customer_panel",
    mailbox: Number(window.shortcodes_data.mailbox_id),
  };

  const getCurrentSubmit = (action) => {
    let currentSubmission = {
      mailbox: shortcodes_data.mailbox_id,
      action: action,
    };
    return currentSubmission;
  };

  const handleFilesChange = (e) => {
    setUplaodFiles(e.target.files);
  };
  const handleUploadClick = () => {
    uploadref.current.click();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newData = {};

    const formdata = new FormData(form.current);

    let currentSubmission = {
      mailbox: shortcodes_data.mailbox_id,
      action: "add_ticket_from_customer_panel",
    };

    Object.entries(currentSubmission).forEach(function ([key, value]) {
      formdata.append(key, value);
    });

    const requiredFields = fields.filter((field) => field.fieldrequire);

    const missingFields = requiredFields.filter(
      (field) => !formData[field.metakey]
    );

    if (missingFields.length > 0) {
      missingFields.forEach((field, index) => {
        setFormerror((prevstate) => ({
          ...prevstate,
          [field.metakey]: field.errormsg
            ? field.errormsg
            : `${field.label} can't be empty`,
        }));
      });
      return;
    }

    setSubmitLoading(true);

    for (let [key, value] of formdata.entries()) {
      if (key !== "action" && key !== "mailbox") {
        const fieldstrip = fields.find((field) => field.metakey == key);
        formdata.set(
          key,
          JSON.stringify({
            fieldvalue: fieldstrip.type == "checkbox" ? formData[key] : value,
            fieldlabel: fieldstrip.label,
          })
        );
      }
    }

    //
    if (uploadFiles) {
      for (let i = 0; i < uploadFiles.length; i++) {
        formdata.append("files[]", uploadFiles[i]);
      }
    }

    // return;

    try {
      const request = await fetch(hive_front.ajaxurl, {
        method: "POST",
        body: formdata,
      });

      const response = await request.json();

      if (response.success) {
        // alert('Success');
        setUplaodFiles(null);
        if (response.data.notice_type == "success") {
          setAllTicketClick(true);
          fireNotify( __( "Ticket is successfully added!", "hive-support" ), "success");
        }
      }
    } catch (error) {
      fireNotify( __( "Something went wrong", "hive-support" ), "error");
    }
  };
  const handleXSubmit = async (e) => {
    e.preventDefault();

    const formdata = new FormData(form.current);

    formdata.append("action", "add_ticket_from_customer_panel");
    formdata.append("mailbox", Number(window.shortcodes_data.mailbox_id));

    const requiredFields = fields.filter((field) => field.fieldrequire);

    const missingFields = requiredFields.filter(
      (field) => !formData[field.metakey]
    );

    if (missingFields.length > 0) {
      missingFields.forEach((field, index) => {
        //setFormerror({ ...formError, [field.metakey]: `${field.label} can't be empty` });
        setFormerror((prevstate) => ({
          ...prevstate,
          [field.metakey]: field.errormsg
            ? field.errormsg
            : `${field.label} can't be empty`,
        }));
      });
      return;
    }

    setSubmitLoading(true);

    for (let [key, value] of formdata.entries()) {
      if (key !== "action" && key !== "mailbox") {
        const fieldstrip = fields.find((field) => field.metakey == key);
        formdata.set(
          key,
          JSON.stringify({
            fieldvalue: fieldstrip.type == "checkbox" ? formData[key] : value,
            fieldlabel: fieldstrip.label,
          })
        );
      }
    }

    const response = await fetch(hive_front.ajaxurl, {
      method: "POST",
      body: formdata,
    });

    const result = await response.json();
    if (result) {
      setAllTicketClick(true);
    }
  };

  const handleFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newvalue = value;
    if (type === "checkbox") {
      const checkbox_values = formData[name] || [];
      newvalue = checked
        ? [...checkbox_values, value]
        : checkbox_values.filter((val) => val !== value);
    }
    setFormData({ ...formData, [name]: newvalue });
  };

  // Components
  const Loader = () => {
    return (
      <div
        className="w-full h-screen flex justify-center items-center"
        style={{ display: "flex", justifyContent: "center", marginTop: "30px" }}
      >
        <div class="hive_support_loader"></div>
      </div>
    );
  };

  useEffect(() => {
    getTicketFields();
    return () => {
      setAllTicketClick(false);
      setSubmitLoading(false);
    };
  }, []);
  if (allTicketClick) {
    return <Tickets />;
  }
  return (
    <form ref={form}>
      <div className="hive_support_client_form">
        <div className="hive_support_client_form_header">
          <h4>{__( "Create New Ticket", "hive-support" )} </h4>
          <button class="show_tickets" onClick={() => setAllTicketClick(true)}>
            {__( "All Tickets", "hive-support" )}
          </button>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <div className="hive_support_client_form_body">
            {Array.isArray(fields) &&
              fields.map((field, index) => {
                if (field.type == "text") {
                  return (
                    <div className="hive_support_single_form_element">
                      <label
                        className="hive_support_element_label"
                        htmlFor="hive_support_field_id_sedbrgclo"
                      >
                        {field.label}
                      </label>
                      <div className="hive_support_element_field_main">
                        <input
                          id="hive_support_field_id_sedbrgclo"
                          type="text"
                          name={field.metakey}
                          onChange={handleFieldChange}
                        />
                      </div>
                      {formError[field.metakey] && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "4px",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {formError[field.metakey]}
                        </p>
                      )}
                    </div>
                  );
                } else if (field.type == "number") {
                  return (
                    <div className="hive_support_single_form_element">
                      <label
                        className="hive_support_element_label"
                        htmlFor="hive_support_field_id_sedbrgclo"
                      >
                        {field.label}
                      </label>
                      <div className="hive_support_element_field_main">
                        <input
                          id="hive_support_field_id_sedbrgclo"
                          type="number"
                          required=""
                          name={field.metakey}
                          onChange={handleFieldChange}
                        />
                      </div>
                      {formError[field.metakey] && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "4px",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {formError[field.metakey]}
                        </p>
                      )}
                    </div>
                  );
                } else if (field.type == "dropdown") {
                  return (
                    <div className="hive_support_single_form_element">
                      <label
                        className="hive_support_element_label"
                        htmlFor="hive_support_field_id_q0hj5vgtb"
                      >
                        {field.label}
                      </label>
                      <div className="hive_support_element_field_main">
                        <select
                          name={field.metakey}
                          onChange={handleFieldChange}
                        >
                          {field.options.map((option) => (
                            <option value={option.value}>{option.value}</option>
                          ))}
                        </select>
                      </div>
                      {formError[field.metakey] && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "4px",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {formError[field.metakey]}
                        </p>
                      )}
                    </div>
                  );
                } else if (field.type == "radio") {
                  return (
                    <div className="hive_support_single_form_element">
                      <label className="hive_support_element_label">
                        {field.label}
                      </label>
                      <div className="hive_support_element_field_main">
                        <div className="radio_container">
                          {Array.isArray(field.options) &&
                            field.options.map((option) => (
                              <label className="radio_item">
                                {option.value}
                                <input
                                  type="radio"
                                  value={option.value}
                                  className="radio_zpmtr4e3v"
                                  name={field.metakey}
                                  onChange={handleFieldChange}
                                />
                                <span className="checkmark" />
                              </label>
                            ))}
                        </div>
                      </div>
                      {formError[field.metakey] && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "4px",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {formError[field.metakey]}
                        </p>
                      )}
                    </div>
                  );
                } else if (field.type == "checkbox") {
                  return (
                    <div className="hive_support_single_form_element">
                      <label className="hive_support_element_label">
                        {field.label}
                      </label>
                      <div className="hive_support_element_field_main">
                        <div className="checkbox_container">
                          {Array.isArray(field.options) &&
                            field.options.map((option) => (
                              <label className="checkbox_item">
                                {option.value}
                                <input
                                  type="checkbox"
                                  className="checkbox_ragc5jtwj"
                                  value={option.value}
                                  name={field.metakey}
                                  onChange={handleFieldChange}
                                />
                                <span className="checkmark" />
                              </label>
                            ))}
                        </div>
                      </div>
                      {formError[field.metakey] && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "4px",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {formError[field.metakey]}
                        </p>
                      )}
                    </div>
                  );
                } else if (field.type == "media") {
                  const uploadfiledata = [];

                  const isSupportedImage = (file) => {
                    const supportedImageTypes = [
                      "jpeg",
                      "png",
                      "gif",
                      "jpg",
                      "webp",
                    ];
                    return supportedImageTypes.some((type) =>
                      file.type.includes(type)
                    );
                  };
                  if (uploadFiles) {
                    for (let i = 0; i < uploadFiles.length; i++) {
                      
                      if (isSupportedImage(uploadFiles[i])) {
                        const img = URL.createObjectURL(uploadFiles[i]);
                        uploadfiledata.push({
                          type: "image",
                          img_src: img,
                        });
                      } else {
                        uploadfiledata.push({
                          type: "image",
                          filename: uploadFiles[i].name,
                        });
                      }
                    }
                  }

                  return (
                    <div className="hive-support-media-upload-preview-wrap">
                      <div className="flex-wrap media-upload-preview">
                        {Array.isArray(uploadfiledata) &&
                          uploadfiledata.map((file, index) => {
                            if (file.img_src) {
                              return <img src={file.img_src} alt="" />;
                            } else {
                              return <p>{__( "This is file name", "hive-support" )}</p>;
                            }
                            
                          })}
                      </div>
                      <div
                        className="ticket_media_upload"
                        onClick={handleUploadClick}
                      >
                        <svg
                          width="18"
                          height="20"
                          viewBox="0 0 18 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.0799 10.42L9.89992 16.61C9.08973 17.33 8.03506 17.7132 6.95164 17.6814C5.86821 17.6495 4.83792 17.2048 4.07149 16.4384C3.30506 15.672 2.86043 14.6417 2.82853 13.5582C2.79664 12.4748 3.1799 11.4202 3.89992 10.61L11.8999 2.60997C12.3775 2.15627 13.0112 1.9033 13.6699 1.9033C14.3287 1.9033 14.9623 2.15627 15.4399 2.60997C15.9053 3.08156 16.1662 3.71744 16.1662 4.37997C16.1662 5.0425 15.9053 5.67838 15.4399 6.14997L8.53992 13.04C8.47163 13.1135 8.38952 13.1729 8.29829 13.2147C8.20706 13.2565 8.10849 13.2799 8.0082 13.2836C7.90791 13.2874 7.80788 13.2713 7.7138 13.2363C7.61973 13.2014 7.53346 13.1483 7.45992 13.08C7.38638 13.0117 7.32701 12.9296 7.2852 12.8383C7.24339 12.7471 7.21995 12.6485 7.21624 12.5483C7.21253 12.448 7.2286 12.3479 7.26355 12.2539C7.29849 12.1598 7.35163 12.0735 7.41992 12L12.5499 6.87997C12.7382 6.69166 12.844 6.43627 12.844 6.16997C12.844 5.90367 12.7382 5.64827 12.5499 5.45997C12.3616 5.27166 12.1062 5.16588 11.8399 5.16588C11.5736 5.16588 11.3182 5.27166 11.1299 5.45997L5.99992 10.6C5.74322 10.8547 5.53948 11.1577 5.40045 11.4915C5.26141 11.8253 5.18983 12.1834 5.18983 12.545C5.18983 12.9066 5.26141 13.2646 5.40045 13.5984C5.53948 13.9323 5.74322 14.2353 5.99992 14.49C6.52429 14.9895 7.22072 15.2681 7.94492 15.2681C8.66911 15.2681 9.36554 14.9895 9.88992 14.49L16.7799 7.58997C17.5748 6.73692 18.0075 5.60864 17.987 4.44283C17.9664 3.27703 17.4941 2.16472 16.6696 1.34024C15.8452 0.515759 14.7329 0.0434872 13.5671 0.0229179C12.4012 0.00234858 11.273 0.435088 10.4199 1.22997L2.41992 9.22997C1.34111 10.4248 0.764944 11.9898 0.811449 13.5989C0.857954 15.2081 1.52355 16.7372 2.66955 17.8677C3.81556 18.9983 5.35359 19.643 6.9632 19.6677C8.57281 19.6923 10.1299 19.0949 11.3099 18L17.4999 11.82C17.5932 11.7267 17.6671 11.616 17.7176 11.4942C17.768 11.3724 17.794 11.2418 17.794 11.11C17.794 10.9781 17.768 10.8475 17.7176 10.7257C17.6671 10.6039 17.5932 10.4932 17.4999 10.4C17.4067 10.3067 17.296 10.2328 17.1742 10.1823C17.0523 10.1318 16.9218 10.1059 16.7899 10.1059C16.6581 10.1059 16.5275 10.1318 16.4057 10.1823C16.2838 10.2328 16.1732 10.3067 16.0799 10.4V10.42Z"
                            fill="#1F8FEB"
                          />
                        </svg>

                        <p className="upload_text">
                          {__( "Drag and drop or Click here to upload file", "hive-support" )}
                        </p>
                        <input
                          ref={uploadref}
                          type="file"
                          style={{ display: "none" }}
                          onChange={handleFilesChange}
                          multiple="multiple"
                        />
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div className="hive_support_single_form_element">
                      <label
                        className="hive_support_element_label"
                        htmlFor="hive_support_field_id_56b179j4j"
                      >
                        {__( "Message", "hive-support" )}
                      </label>
                      <div className="hive_support_element_field_main">
                        <textarea
                          name={field.metakey}
                          onChange={handleFieldChange}
                          id="hive_support_field_id_56b179j4j"
                          rows={4}
                        />
                      </div>
                      {formError[field.metakey] && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "4px",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {formError[field.metakey]}
                        </p>
                      )}
                    </div>
                  );
                }
              })}

            <div
              onClick={handleSubmit}
              className="hive_support_single_form_element"
              data-field_slug="submit_btn"
            >
              <div className="custom_btn_container">
                <button
                  type="submit"
                  className="reply"
                  style={{ padding: "10px" }}
                >
                  {submitLoading ? (
                    <div class="submitting_loader"></div>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default AddTicket;
